<template>
  <div>
    <el-dialog :visible.sync="visible" width="900px" title="管理员" @close="handleClose" append-to-body>
      <div>
        <el-button type="primary" @click="showAddDialog" size="small" round>+ 添加管理员</el-button>
        <el-table :data="adminList" style="width: 100%; margin-top: 20px;">
          <el-table-column label="头像/邮箱" width="120">
            <template slot-scope="scope">
              <el-avatar :src="scope.row.adminAvatar" />
            </template>
          </el-table-column>
          <el-table-column prop="adminName" label="管理员姓名" />
          <el-table-column prop="adminPosition" label="管理员身份" />
          <el-table-column prop="adminPhone" label="管理员手机号" />
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="primary" @click="removeAdmin(scope.$index)">移除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </div>
    </el-dialog>
    <el-dialog :visible.sync="formVisible" width="600px" title="添加管理员" @close="handleClose" append-to-body>
      <el-form :model="form" label-width="80px" ref="dataForm" size="small">
        <el-form-item label="管理员" required>
          <el-select v-model="form.userId" :disabled="form.id" filterable remote placeholder="请输入手机号/姓名进行搜索" :remote-method="searchUsers" :loading="loading">
            <el-option v-for="item in usersOptions" :key="item.id" :label="item.realName + '('+ item.userPho+')' + item.position" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin-top: 30px;">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import liveManageApi from '@/api/live/liveManage'
import Pagination from '@/components/Pagination'
function initFormBean() {
  const formBean = {
    id: null,
    liveName: null,
    userId: null,
    state: 1
  }
  return formBean
}
export default {
  components: {
    Pagination
  },
  data() {
    return {
      visible: false,
      formVisible: false,
      adminList: [],
      total: 0,
      listLoading: false,
      form: initFormBean(),
      rules: {
        userId: [{ required: true, message: '请选择管理员', trigger: 'change' }]
      },
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      adminOptions: [],
      loading: false,
      usersOptions: [],
    }
  },
  methods: {
    searchUsers(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          liveManageApi.searchUser({ keyword: query }).then(({ data }) => {
            this.usersOptions = data;
          })
        }, 500);
      } else {
        this.options = [];
      }
    },
    handleShow(row) {
      this.form.liveId = row.id
      this.doQueryList()
      this.visible = true
    },
    handleClose() {
      this.visible = false
    },
    doQueryList() {
      this.listLoading = true
      return liveManageApi.fetchListAdmin(this.query)
        .then(data => {
          this.adminList = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    showAddDialog() {
      this.formVisible = true
    },
    removeAdmin(idx) {
      this.$common.confirm('确认移除管理员？').then(() => {
        liveManageApi.deleteBatchAdmin([this.adminList[idx].id]).then(() => {
          this.$message.success('移除成功')
          this.doQueryList()
        })
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          liveManageApi.createAdmin(this.form).then((data) => {
            this.postCallback(data)
          }).catch(res => {
            this.isRepSub = false
          });
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
</style>